import React, { useEffect, useState } from "react";

const COLORS = ["#D4A017", "#0C4A38", "#E23B3B", "#1E9E6A", "#C7920F", "#f5eac9"];

export function Confetti({ count = 90, duration = 3500, onDone }) {
  const [pieces] = useState(() =>
    Array.from({ length: count }).map((_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * 0.6,
      dur: 2.2 + Math.random() * 1.6,
      color: COLORS[i % COLORS.length],
      size: 7 + Math.random() * 8,
      rot: Math.random() * 360,
    }))
  );

  useEffect(() => {
    const t = setTimeout(() => onDone && onDone(), duration);
    return () => clearTimeout(t);
  }, [duration, onDone]);

  return (
    <div className="confetti-layer" data-testid="confetti">
      {pieces.map((p) => (
        <span
          key={p.id}
          style={{
            left: `${p.left}%`,
            width: p.size,
            height: p.size * 0.5,
            background: p.color,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.dur}s`,
            transform: `rotate(${p.rot}deg)`,
          }}
        />
      ))}
    </div>
  );
}
